let pageConfig = {};

// 面包屑
pageConfig.listBreadCrumb = [
  {
    type: "title",
    name: "首页",
  },
  {
    type: "title",
    name: "清分账户",
  },
];

// 详情的面包屑
pageConfig.detailBreadCrumb = [
  {
    type: "title",
    name: "首页",
  },
  {
    type: "router",
    name: "清分规则",
    router: "clearAccount",
  },
  {
    type: "title",
    name: "清分账户详情",
  },
];

// 列表展示项
pageConfig.listColumns = [
  {
    label: "清分账户号",
    props: "dealName",
    minWidth: 200,
  },
  {
    label: "清分账户类型",
    props: "accountTypeName",
    minWidth: 200,
  },
  {
    label: "清分账户名称",
    props: "accountName",
    minWidth: 200,
  },
  {
    label: "所属运营商",
    props: "dealName",
    minWidth: 200,
  },
  {
    label: "参与分成站点",
    props: "stationName",
    minWidth: 200,
  },
  {
    label: "企业名称",
    props: "companyName",
    minWidth: 240,
  },
  {
    label: "法人",
    props: "legalEntityName",
    minWidth: 120,
  },
  {
    label: "银行账户",
    props: "receiveBankCardNo",
    minWidth: 240,
  },
  {
    label: "分成状态",
    props: "splitActiveStatusName",
    minWidth: 180,
  },
  {
    label: "提现状态",
    props: "splitPayoutStatusName",
    minWidth: 180,
  },
  {
    label: "账户状态",
    props: "accountStatus",
    minWidth: 180,
    formatter: (row, column, cellValue, index) => {
      if (row.accountStatus === 'NOT_CERTIFIED') return '待认证';
      if (row.accountStatus === 'NOT_CONFIG') return '已认证，待设置';
      if (row.accountStatus === 'RUNNING') return '使用中';
    },
  },
  {
    label: "创建时间",
    props: "createdWhen",
    minWidth: 200,
  },
];

// 列表-表格属性
pageConfig.tableConfig = {
  showSelection: true,
  showIndex: true,
  herderStyle: {
    background: "#FAFAFA",
    color: "#8F9BB3",
    fontSize: "14px",
    fontFamily: "PingFangSC-Medium, PingFang SC",
  },
};

// 列表-分页参数
pageConfig.pagination = {
  current: 1,
  total: 0,
  pageSize: 10,
  pageSizes: [2, 3, 4, 5, 10, 20, 50, 100],
};

// 列表-编辑操作
pageConfig.tableEditObj = {
  editKey: "id",
  editRouter: "clearDetail",
};

pageConfig.rules = {
  accountName: [
    {
      required: true,
      message: "请填写清分账户的商户名称",
      trigger: "blur",
    },
  ],
  accountType: [
    {
      required: true,
      message: "请选择清分账户类型",
      trigger: "blur",
    },
  ],
  dealNo: [
    {
      required: true,
      message: "请选择运营商名称",
      trigger: "blur",
    },
  ],
};

export default pageConfig;
